<template>
	<div class="currently--detail" :data-title="currently.current_title">
		<div class="text"><prismic-rich-text :field="currently.current_text" /></div>
		<div class="image"><prismic-image :field="currently.current_thumbnail" /></div>
	</div>
</template>

<script>
import prismicDOM from 'prismic-dom';

export default {
  name: 'Currently',
  props: ['currently'],
  data () {
    return {
	    uid: null,
      title: null,
      content: null,
      clients: []
    }
  },
  components: {
  },
  methods: {
  },
  created () {
  },
  mounted() {
  }
}
</script>

<style>

</style>